<template>
  <div>
    <div
      class="flex justify-between cursor-pointer py-2.5 px-5 leading-relaxed font-bold bg-EXPONDO-grey-5 gap-1"
      @click="$emit('toggle-accordion')"
    >
      <div class="flex items-center gap-3">
        <div class="w-6 shrink-0 flex justify-center items-center">
          <span
            :class="icon"
          />
        </div>
        <span>
          {{ title }}
        </span>
      </div>
      <div class="flex items-center text-EXPONDO-grey text-xxs">
        <span
          v-if="!isOpen"
          class="iconify svg--accordion-open"
        />
        <span
          v-else
          class="iconify svg--accordion-close"
        />
      </div>
    </div>
    <div
      v-show="isOpen"
      class="px-5 pt-5"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'TrustAccordionItem',
  props: {
    title: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  emits: ['toggle-accordion'],
});

</script>
